import i18next from 'i18next';
import ICU from 'i18next-icu';

export default function i18n(locale: string) {
  void i18next
    .use(ICU)
    .use({
      type: 'backend',
      read: (
        language: string,
        namespace: string,
        callback: (
          err: any | null,
          translations?: Record<string, string>,
        ) => void,
      ) => {
        console.log(namespace);

        return import(`./assets/locale/messages_${language}.json`)
          .then((translation: Record<string, string>) =>
            callback(null, translation),
          )
          .catch(error => callback(error));
      },
    })
    .init({
      lng: locale,
      fallbackLng: 'en',
      keySeparator: false,
      interpolation: {
        escapeValue: false,
        prefix: '{',
        suffix: '}',
      },
      react: {
        wait: true,
      },
    });

  return i18next;
}
